<template>
  <section class="second">
    <div class="container">
      <div class="wrap">
        <h3>Education</h3>
      </div>
      <div class="uni" data-aos="fade-right" data-aos-duration="3000">
        <img src="../assets/media/university.svg.png" />
        <div>
          <p>Bachelor of Science</p>
          <p>2010 - 2015</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "EducationComponent",
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 1280px;
  margin: 5rem auto 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .wrap {
    background-image: linear-gradient(
      to top,
      #fff 50%,
      #2f9e44 50%,
      #2f9e44 75%,
      #fff 75%
    );

    h3 {
      border-bottom: 3px solid #1f0d14;
      padding: 0 1.5rem;
      margin: 3rem 9rem;
      font-family: "Acme", Arial, sans-serif;
      font-size: 3rem;
      color: #1f0d14;
      filter: drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4));
    }
  }

  .uni {
    width: 40rem;
    display: flex;
    align-items: center;

    img {
      margin-left: 2rem;
      width: 20rem;
      height: 100%;
    }

    p {
      margin: 0 0 0 2rem;
      font-size: 1.6rem;
      line-height: 2.5rem;
    }
  }
}

@media screen and (max-width: 750px) {
  .container {
    align-items: center;
    margin: 0 auto;
    scale: 0.85;

    .uni {
      justify-content: center;

      img {
        margin-left: 0;
        width: 17rem;
      }
      p {
        font-size: 1.5rem;
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .container {
    .wrap {
      h3 {
        margin: 3rem 5rem;
      }
    }
  }
  .uni {
    flex-direction: column;

    p {
      padding-top: 0.5rem;
    }
  }
}
</style>
